import { create } from "zustand";

/**
 * Zustand store for the Alpaca US Options Straddle Screener.
 * Populated by the server via the global LTP WebSocket (ALPACA_STRADDLE_SNAPSHOT).
 *
 * Each item in `straddles`:
 * {
 *   symbol, asset_name, asset_bucket, underlying_price,
 *   expiration_date, dte, atm_strike, ce_symbol, pe_symbol,
 *   ce_mid, pe_mid, ce_last, pe_last, ce_close, pe_close,
 *   straddle_mid, straddle_last, straddle_mid_pct
 * }
 */
const useAlpacaStraddleStore = create((set) => ({
    straddles: [],
    lastUpdated: null,

    setSnapshot: (data) =>
        set({
            straddles: Array.isArray(data) ? data : [],
            lastUpdated: Date.now(),
        }),

    clearSnapshot: () => set({ straddles: [], lastUpdated: null }),
}));

export default useAlpacaStraddleStore;
